import Navmenu from 'components/Navmenu';
import React, { ReactElement, ReactNode } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

export const DefaultLayout = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => (
  <>
    <Navmenu />
    <Container>
      <Row>
        <Col />
        <Col md={6}>
          <div className="container-fluid main-container">{children}</div>
        </Col>
        <Col />
      </Row>
    </Container>
  </>
);
export default DefaultLayout;
